import { CheckUrlMeta, CheckUrlPayload } from 'types/store/CheckUrlState';
import { createAsyncReducer } from 'utils/Redux';

import { checkUrlActions } from '../actions';

export default createAsyncReducer<CheckUrlMeta, CheckUrlPayload>(
  checkUrlActions
);
